import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import { ASTERISK_PLACEHOLDER } from "modules/DealerOverviewDashboard/components";

import type { Dealer } from "models";
import type { DealerAdminFormPayload } from "modules/DealerDetails";

const FormHelper = createFormHelper<DealerAdminFormPayload>();

type ServiceProps = {
  tabId: string;
  dealer: Dealer;
};

export const Service = ({ tabId, dealer }: ServiceProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="dealer-details-section">
      <div className="section-title">
        <div>
          <Icon className="wrench" />
        </div>
        <span className="section-title-text">{t("v8_service", "Service")}</span>
      </div>
      <div className="dealer-details-subheading">{t("v8_lef_configuration", "LEF configuration")}</div>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_username", "Username")}</label>
          <FormHelper.Field.Input name="lef_username" preventAutofill />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_password", "Password")}</label>
          <FormHelper.Field.Input
            name="lef_password"
            preventAutofill
            inputProps={{ type: "password", placeholder: dealer.has_lef_password ? ASTERISK_PLACEHOLDER : "" }}
          />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
